export default "__VITE_ASSET__BNdPjcM6__"